const Events = {
  onLanguageSelect: 'onLanguageSelect',
  onMeasureOptionSelect: 'onMeasureOptionSelect',
  onMeasureOptionConfirm: 'onMeasureOptionConfirm',
  onSpeedOptionSelect: 'onSpeedOptionSelect',
  onSpeedOptionConfirm: 'onSpeedOptionConfirm',
  onContinuePress: 'onContinuePress',
};

export default Events;
